import { connect } from 'react-redux'

import CompteTiersModal from '../../../pages/settings/components/Modals/CompteTiersModal'
import {
  getErrorMessage,
  getisLoadingCompteTiersAction,
  getSuccess,
} from '../../../redux/compteTiers/selectors'
import {
  createCompteTiers,
  resetCompteTiersConfig,
  updateCompteTiers,
} from '../../../redux/compteTiers/actions'
import {
  fetchKeys,
  fetchSalesChannels,
  fetchSalesChannelsMore,
  getKeysMore,
  onSearchCleCompetence,
  pageChangedKeys,
  resetConfig,
} from '../../../redux/configuration/actions'
import {
  getErrorMessageConfig,
  getIsLoadingSalesChannelList,
  getKeys,
  getKeysCount,
  getKeysListIsLoading,
  getSalesChannelList,
  getSalesChannelListCount,
} from '../../../redux/configuration/selectors'

const mapStateToProps = (state) => ({
  isLoadingCompteTiersAction: getisLoadingCompteTiersAction(state),
  success: getSuccess(state),
  errorMessage: getErrorMessage(state),

  salesChannelList: getSalesChannelList(state),
  isLoadingSalesChannelList: getIsLoadingSalesChannelList(state),
  salesChannelListCount: getSalesChannelListCount(state),

  errorMessageConfig: getErrorMessageConfig(state),
  keys: getKeys(state),
  isLoadingKeysList: getKeysListIsLoading(state),
  keysCount: getKeysCount(state),
})

const mapDisptachToProps = (dispatch) => ({
  createCompteTiers: (compteTiers) => dispatch(createCompteTiers(compteTiers)),
  updateCompteTiers: (newCompteTiers, id) =>
    dispatch(updateCompteTiers(newCompteTiers, id)),
  resetCompteTiersConfig: () => dispatch(resetCompteTiersConfig()),

  getSalesChannels: (filter) => dispatch(fetchSalesChannels(filter)),
  getSalesChannelsMore: (filter) => dispatch(fetchSalesChannelsMore(filter)),

  fetchKeys: () => {
    dispatch(onSearchCleCompetence(''))
    dispatch(fetchKeys())
  },
  searchKeys: (search) => {
    dispatch(onSearchCleCompetence(search))
    dispatch(pageChangedKeys(0))
    dispatch(fetchKeys())
  },
  fetchMoreKeys: (offset, search) => {
    dispatch(onSearchCleCompetence(search))
    dispatch(pageChangedKeys(offset))
    dispatch(getKeysMore())
  },
  resetKey: () => dispatch(resetConfig()),
})

export default connect(mapStateToProps, mapDisptachToProps)(CompteTiersModal)
